import { IS_DEV } from '../autogen/version';
import notifier from '../notifier';

let prodConfirmationWindow = null;

export function setProdConfirmationWindow(w) {
  prodConfirmationWindow = w;
}

/**
 * @param {Object} page
 * @param {string} messageTemplate
 * @param {string} actionName
 * @param {ConfirmHandle} onConfirmed
 */
export function confirmAction(page, messageTemplate, actionName, onConfirmed, paramObject) {
  if(IS_DEV) {
    confirmActionInDevEnv(page, messageTemplate, actionName, onConfirmed, paramObject);
  } else {
    confirmActionInProdEnv(page, messageTemplate, actionName, onConfirmed, paramObject);
  }
}

// Example
// messageTemplate: 'Are you sure you want to delete this game event {env}?'

/**
 * @typedef {function(): void} ConfirmHandle
 */

/**
 * @param {Object} page
 * @param {string} messageTemplate
 * @param {string} actionName
 * @param {ConfirmHandle} onConfirmed
 */
function confirmActionInDevEnv(page, messageTemplate, actionName, onConfirmed, paramObject) {
  const h = page.$createElement;

  const vNodes = [];

  {
    const text = getMessageWithoutEnvMark(messageTemplate);
    const textVNode = h('p', {}, text);
    vNodes.push(textVNode);
  }

  if(paramObject !== undefined && paramObject.description !== undefined) {
    const description = paramObject.description;
    const descriptionVNode = h('p', {class: ['mt-1']}, description);
    vNodes.push(descriptionVNode);
  }

  page.$bvModal.msgBoxConfirm(
    vNodes,
    {
      okTitle: actionName,
      okVariant: 'danger',
    }
  )
  .then(confirmed => {
    if(confirmed) {
      onConfirmed();
    }
  })
  .catch(err => {
    notifier.showError(err, {sender: page});
  });
}

/**
 * @param {Object} page
 * @param {string} message
 * @param {string} actionName
 * @param {ConfirmHandle} onConfirmed
 */
function confirmActionInProdEnv(page, message, actionName, onConfirmed, paramObject) {
  if(prodConfirmationWindow === null) {
    notifier.showError('Can not show confirmation. Prod confirmation window is not set.', {sender: page});
    return;
  }

  prodConfirmationWindow.show(page, message, actionName, onConfirmed, paramObject);
}

// Example
// massage: 'Are you sure you want to delete this game event {env}?'
// result:  'Are you sure you want to delete this game event?'
function getMessageWithoutEnvMark(messageTemplate) {
  const envMark = '{env}';
  const endMarkWithLeadingSpace = ' ' + envMark;

  return messageTemplate.replace(endMarkWithLeadingSpace, '');
}
